import Modules from './born.modules.js';
import Pages from './pages.js';

/**
 * This very simple function loops through lists of objects and runs their 'init' method if the 'default' or the *key* query matches an element on the page. 
 * @param  {[Object]} obj 
 */
function applyFns(obj) {
	for (var key in obj) {
		var query = obj[key].default || key;

		if (document.querySelector(query)) {
			obj[key].init(query);
		}
	}
}

export default function(){
	applyFns(Modules);
	applyFns(Pages);
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/helpers/router.js